import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Spin } from "antd";

const DonutChart = ({
  data = [],
  dataKey = "",
  nameKey = "",
  colors = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FF4560",
    "#6A5ACD",
    "#32CD32",
  ],
  chartWidth = "100%",
  chartHeight = 300,
  innerRadius = 60,
  outerRadius = 120,
  loading = false,
}) => {
  // Calculate total to determine percentages
  const total = data.reduce((sum, entry) => sum + (entry[dataKey] || 0), 0);

  // Enhance data with calculated percentages
  const enhancedData = data.map((entry) => ({
    ...entry,
    percentage: total > 0 ? (entry[dataKey] / total) * 100 : 0,
  }));

  return (
    <div className="flex flex-col items-center justify-between">
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <div className="loader"><Spin/></div>
        </div>
      ) : (
        <>
          <ResponsiveContainer width={chartWidth} height={chartHeight}>
          <PieChart >
            <Pie
              key={Math.random()}
              data={enhancedData}
              cornerRadius={6}
              cx="50%"
              cy="50%"
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              fill="#8884d8"
              dataKey="percentage"
              nameKey={nameKey}
              paddingAngle={2}
              label={({ name, percentage }) =>
                `${name}: ${percentage.toFixed(2)}%`
              }
            >
              {enhancedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => `${value.toFixed(2)}%`}
            />
            {/* <Legend
            align="center"
            verticalAlign="bottom"
            layout="horizontal"
            height={36}
            iconType="circle"
          /> */}
          </PieChart>
          </ResponsiveContainer>
          <div className="flex items-center justify-center gap-2 flex-wrap pb-3 px-3">
            {data?.map((entry, index) => (
              <div
                key={`stat-${index}`}
                className="flex items-center gap-3 p-1 bg-white rounded-md border hover:bg-gray-100 transition-colors duration-200"
              >
                <div
                  className="h-4 w-4 rounded-full"
                  style={{ backgroundColor: colors[index % colors.length] }}
                />
                <span className="text-sm font-medium text-gray-700">
                  {entry[nameKey]}
                </span>
                <span className="text-sm font-bold text-gray-900">
                  ({entry[dataKey]})
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DonutChart;
